import React from "react";

function Loader() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/80 backdrop-blur-sm">
      <div className="relative flex items-center justify-center">

        {/* Outer Glow */}
        <div className="absolute w-40 h-40 bg-blue-600/30 rounded-full blur-3xl animate-pulse"></div>

        {/* Center Core */}
        <div className="absolute w-6 h-6 bg-blue-500 rounded-full shadow-[0_0_20px_#3b82f6] animate-ping"></div>

        {/* Rings */}
        <div className="loader-container">
          <div className="ring ring1"></div>
          <div className="ring ring2"></div>
          <div className="ring ring3"></div>
        </div>

        {/* Text */}
        <span className="absolute top-28 text-blue-300 text-sm tracking-widest uppercase font-medium animate-pulse">
          Loading...
        </span>
      </div>

      <style jsx>{`
        .loader-container {
          position: relative;
          width: 100px;
          height: 100px;
        }

        .ring {
          position: absolute;
          border-radius: 50%;
          border: 3px solid transparent;
        }

        .ring1 {
          width: 100px;
          height: 100px;
          border-top: 3px solid #60a5fa;
          border-right: 3px solid #3b82f6;
          animation: spin 2s linear infinite;
        }

        .ring2 {
          width: 70px;
          height: 70px;
          top: 15px;
          left: 15px;
          border-bottom: 3px solid #3b82f6;
          border-left: 3px solid #2563eb;
          animation: spinReverse 1.6s linear infinite;
        }

        .ring3 {
          width: 40px;
          height: 40px;
          top: 30px;
          left: 30px;
          border-top: 3px solid #1d4ed8;
          animation: spin 1.2s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg) scale(1); }
          50% { transform: rotate(180deg) scale(1.05); }
          100% { transform: rotate(360deg) scale(1); }
        }

        @keyframes spinReverse {
          0% { transform: rotate(360deg); }
          100% { transform: rotate(0deg); }
        }
      `}</style>
    </div>
  );
}

export default Loader;
